export const SET_LEURIS_PROFILE = (state, data) => {
  state.leurisProfile = data
}

export const SET_RESEARCH_ACTIVITY_AS_FAVOURITE = (state, data) => {
  state.favouredResearchActivity = data
}

export const SET_FISPERSID = (state, fisPersid) => {
  state.fisPersid = fisPersid
}

export const SET_NAME = (state, name) => {
  state.name = name
}

export const IS_LOADING = (state, loadingState) => {
  state.loading = loadingState || false
}

export const LOADING_DONE = (state) => {
  state.loading = false
}

export const CHANGE_PAGE = (state, { resourceType, page }) => {
  state.config[resourceType].page = page
}

export const SET_ACTIVE_TAB = (state, activeTab) => {
  state.activeTab = activeTab
}

export const SET_CONFIG = (state, { resourceType, property, value }) => {
  state.config[resourceType][property] = value
}

export const SET_DATA = (state, { resourceType, data }) => {
  state.data[resourceType] = data
}

export const SET_TOTAL = (state, { resourceType, total }) => {
  state.total[resourceType] = total
}

export const CHANGE_PER_PAGE = (state, { resourceType, perPage }) => {
  state.config[resourceType].perPage = perPage
}

export const SET_RESOURCE_TYPE = (state, type) => {
  state.resourceType = type
}

export const SET_SORT_FIELD = (state, { resourceType, sortField }) => {
  state.config[resourceType].sortField = sortField
}

export const SET_SORT_ORDER = (state, { resourceType, sortOrder }) => {
  state.config[resourceType].sortOrder = sortOrder
}

export const UPDATE_FILTER = (state, updatedFilter) => {
  state.filter[state.resourceType] = updatedFilter
}

export const RESET = (state) => {
  state.leurisProfile = null
  state.fisPersid = null
  state.name = null

  // reset total
  state.total = {
    forschungsprojekt: 0,
    kooperation: 0,
    publikation: 0,
    veranstaltung: 0,
    preis: 0
  }
  // reset data
  state.data = {
    forschungsprojekt: [],
    kooperation: [],
    publikation: [],
    veranstaltung: [],
    preis: []
  }
  // reset config
  state.filter = {
    forschungsprojekt: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'select', value: 'status', label: 'Public.filter.status', options: ['ONGOING', 'TERMINATED'] },
        { type: 'input', value: 'funding', label: 'Public.filter.mittelgeber', icon: 'credit-card' },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    kooperation: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'externalPartner', label: 'Public.filter.externalPartner', icon: 'globe' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    publikation: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'select', value: 'category', label: 'Public.filter.publikationstypen', options: ['ARTICLE', 'MONOGRAPHY', 'EDITORSHIP', 'CONTRIBUTION', 'REPORT'] },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    veranstaltung: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    },
    preis: {
      filter: {},
      filters: [
        { type: 'input', value: 'year', label: 'Public.filter.jahr', icon: 'calendar', style: { width: '90px' } },
        { type: 'input', value: 'person', label: 'Public.filter.person', icon: 'user' },
        { type: 'input', value: 'freetext', label: 'Public.filter.suche', icon: 'align-left' }
      ]
    }
  }
  // reset config
  state.config = {
    forschungsprojekt: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        // { field: 'TITLE_DE', label: 'Public.sort.titel', locale: 'de' },
        // { field: 'TITLE_EN', label: 'Public.sort.titel', locale: 'en' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
      ],
      sortOrder: 'DESC'
    },
    kooperation: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        // { field: 'TITLE', label: 'Public.sort.titel' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
      ],
      sortOrder: 'DESC'
    },
    publikation: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        // { field: 'TITLE', label: 'Public.sort.titel' },
        { field: 'YEAR', label: 'Public.sort.jahr' }
      ],
      sortOrder: 'DESC'
    },
    veranstaltung: {
      page: 1,
      perPage: 10,
      sortField: 'START_DATE',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        { field: 'START_DATE', label: 'Public.sort.beginn' }
        // { field: 'NAME', label: 'Public.sort.name' }
      ],
      sortOrder: 'DESC'
    },
    preis: {
      page: 1,
      perPage: 10,
      sortField: 'YEAR',
      sortFields: [
        { field: 'TYPE', label: 'Public.sort.typ' },
        { field: 'YEAR', label: 'Public.sort.jahr' },
        { field: 'AWARDEE', label: 'Public.sort.preisTraeger' }
        // { field: 'NAME', label: 'Public.sort.name' }
      ],
      sortOrder: 'DESC'
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/aboutme/mutations.js